import { Injectable } from '@angular/core';
import { WindowVariableService } from '@ecp-caf/caf-common';

@Injectable()
export class FrameworkVariableService {

    private frameworkVariable = 'frameworkVariable';
    private nameSpace = 'variables';
    private frmVariableName = 'rtfFrmVariable';
    private windowService: WindowVariableService;

    constructor() {
        this.windowService = new WindowVariableService();
        this.frmVariableInitial();
    }

    public getFrameworkVariable(): any {
        return this.windowService.getTopWindow()[this.frameworkVariable];
    }

    /**
     * 在框架顶级window注册变量
     */
    public frameworkVariableReg(key: string, value: any) {
        if (key == 'allgspfuncs' || key == 'allfuncinvoks') {
            return;
        }
        const frmVariable = this.getFrameworkVariable();
        if (frmVariable && frmVariable.name && frmVariable.name === this.frmVariableName) {
            frmVariable[this.nameSpace] = frmVariable[this.nameSpace] || {};
            frmVariable[this.nameSpace][key] = value;
            return;
        }
        this.frmVariableInitial();
        this.getFrameworkVariable()[this.nameSpace][key] = value;
    }

    public getFrmVariableByKey(key: string): any {
        const frmVariable = this.getFrameworkVariable();
        if (frmVariable && frmVariable[this.nameSpace] && frmVariable[this.nameSpace][key]) {
            return frmVariable[this.nameSpace][key];
        }
        return null;
    }

    /**
     * 在框架的顶级window上
     * 定义一个公共变量。
     * 用于存放菜单、应用缓存数据，eventbus都公共对象
     * 对适配层提供服务
     */
    private frmVariableInitial() {
        const topWin = this.windowService.getTopWindow();
        const name = 'name';
        topWin[this.frameworkVariable] = topWin[this.frameworkVariable] || {};
        topWin[this.frameworkVariable][name] = this.frmVariableName;
        topWin[this.frameworkVariable][this.nameSpace] = topWin[this.frameworkVariable][this.nameSpace] || {};
    }
}
